export const isNumeric = value =>
  typeof value === 'number' && !isNaN(value) && isFinite(value);
